import { getAttendanceIssue } from 'services/axios/attendanceIssue'

export const actions = {
  HANDLE_ATTENDANCE_ISSUE_PAGINATION: 'HANDLE_ATTENDANCE_ISSUE_PAGINATION',
  HANDLE_ATTENDANCE_ISSUE: 'HANDLE_ATTENDANCE_ISSUE',
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_ATTENDANCE_ISSUE_PAGINATION',
    payload: pagination,
  }
}

export const allAttendanceIssueList = ({
  skip,
  limit,
  searchedEmployee,
  year,
  month,
  depId,
  userProcess,
}) => {
  return async (dispatch) => {
    const response = await getAttendanceIssue({
      skip,
      limit,
      searchedEmployee,
      year,
      month,
      depId,
      userProcess,
    })

    if (response?.status === 200 && response?.data?.message === 'success') {
      dispatch({
        type: actions.HANDLE_ATTENDANCE_ISSUE,
        payload: {
          attendanceIssueList: response?.data?.data?.attendanceIssueList,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    }
  }
}
